import { render, staticRenderFns } from "./successPhone.vue?vue&type=template&id=1ce0abd4&scoped=true"
import script from "./successPhone.vue?vue&type=script&lang=js"
export * from "./successPhone.vue?vue&type=script&lang=js"
import style0 from "./successPhone.vue?vue&type=style&index=0&id=1ce0abd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0abd4",
  null
  
)

export default component.exports